import { useMemo } from 'react'
import namesTopics from '../../namesTopics'
import './_Ticker.scss'

function Ticker() {
	const tickerContent = useMemo(() => {
		let tickerContent: string[] = []
		const namesLength = namesTopics.names.length
		const topicsLength = namesTopics.topics.length

		for (let i = 0; i < 20; i++) {
			tickerContent.push(
				namesTopics.names[Math.floor(Math.random() * namesLength)] +
					' just wrote an essay about: "' +
					namesTopics.topics[Math.floor(Math.random() * topicsLength)] +
					'"'
			)
		}
		return tickerContent
	}, [])

	return (
		<div className="ticker_wrap">
			<div className="ticker">
				{tickerContent.map((tick, key) => {
					return (
						<h6 className="tick header-sm" key={key}>
							{tick}
						</h6>
					)
				})}
			</div>
		</div>
	)
}

export default Ticker
